// Shown to guests only if Supabase is unreachable and nothing is cached yet.
export const FALLBACK_SERVICES = [
  {
    id: "private-1-1",
    slug: "private-1-1",
    title: "1:1 Private Reading Tutoring",
    price_label: "$65 / hour",
    duration: "60 minutes",
    description: "One-on-one, in-person reading instruction tailored to your child's specific decoding, fluency, and comprehension needs. Uses Orton-Gillingham structured literacy with multi-sensory techniques.",
    features: [
      "Orton-Gillingham structured literacy",
      "Multi-sensory (visual, auditory, kinesthetic)",
      "Custom intervention plan based on assessment",
      "Progress monitoring & parent updates",
    ],
    recommended_for: "Children with dyslexia, ADHD, or significant reading gaps",
  },
  {
    id: "small-group",
    slug: "small-group",
    title: "Small Group Reading Tutoring",
    price_label: "$35 / hour",
    duration: "60 minutes",
    description: "Small-group instruction (2–3 students at similar reading levels) for a more affordable, social option. Perfect for kids who benefit from peer modeling.",
    features: [
      "2–3 students per group",
      "Grouped by reading level, not age",
      "Same evidence-based curriculum as 1:1",
      "Builds confidence in a low-pressure setting",
    ],
    recommended_for: "Kids preventing the summer slide or working on similar skill gaps",
  },
  {
    id: "virtual-1-1",
    slug: "virtual-1-1",
    title: "1:1 Virtual / Remote Tutoring",
    price_label: "$65 / hour",
    duration: "60 minutes",
    description: "Same proven 1:1 structured literacy approach, delivered live over video with interactive digital tools. Available to families anywhere in the U.S.",
    features: [
      "Live, face-to-face video sessions",
      "Digital letter tiles & multi-sensory tools",
      "Available nationwide",
      "Flexible scheduling around school & sports",
    ],
    recommended_for: "Families outside the Springboro, OH area or with busy schedules",
  },
];

export const FALLBACK_TESTIMONIALS = [
  {
    id: "fallback-bryce",
    parent_name: "Bryce's Parent",
    child_first_name: "Bryce",
    child_age_or_grade: "4th Grade",
    quote: "Jonna has been critical at keeping our son from falling further behind and closing the gap. Her tutoring style is firm but fun — even with ADHD in the mix, she gets results.",
    rating: 5,
  },
];
